<p-dialog
  class="juniors-upgrade-popup__wrapper"
  [modal]="true"
  [closable]="false"
  [(visible)]="visible"
  [draggable]="false"
  [showHeader]="false"
  [closeOnEscape]="false"
  [dismissableMask]="true"
  (onShow)="trackViewEvent()"
  data-qa="juniorsCourseUpgrade_popup"
>
  <div class="juniors-upgrade-popup__content">
    <h6 class="juniors-upgrade-popup__popup-title" i18n>Why not upgrade your course?</h6>
    <div class="juniors-upgrade-popup__popup-description" i18n>
      Students who choose Intensive courses improve their language confidence much faster. Just one more hour a day of English lessons can make a huge
      difference.
    </div>
    <lx-button
      class="juniors-upgrade-popup__buttons juniors-upgrade-popup__buttons--primary"
      [buttonStyle]="'primary'"
      [btnRounded]="true"
      (buttonClick)="upgradedCourse.emit(true)"
      [lxGAClickEvent]="quoteUpsellingAcceptGAEvent"
      data-qa="juniorsCourseUpgrade_button"
      i18n
      >Yes, add Intensive courses</lx-button
    >
    <lx-button
      [buttonStyle]="'quaternary'"
      [btnRounded]="true"
      class="juniors-upgrade-popup__buttons"
      (buttonClick)="upgradeJuniorsCourse(false)"
      [lxGAClickEvent]="quoteUpsellingDenyGAEvent"
      data-qa="juniorsCourseNoUpgrade_button"
      i18n
      >No, keep Standard courses</lx-button
    >
  </div>
</p-dialog>
